// extracted by css-extract-rspack-plugin
export default {"sidebarTooltip":"SidebarTooltip-module__sidebarTooltip__q2r8Z","sidebar-tooltip-appear":"SidebarTooltip-module__sidebar-tooltip-appear__rtrDd"};